// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-column-settings__subheader {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-2-font-size);
  line-height: var(--g-text-subheader-2-line-height);
  margin-right: 4px;
}
.dialog-column-settings__help-mark {
  vertical-align: text-bottom;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogColumnSettings/components/Subheader/Subheader.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAGI;ECmOA,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;EDpOI,iBAAA;AACR;AAEI;EACI,2BAAA;AAAR","sourcesContent":[".dialog-column-settings__subheader {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-2-font-size);\n  line-height: var(--g-text-subheader-2-line-height);\n  margin-right: 4px;\n}\n.dialog-column-settings__help-mark {\n  vertical-align: text-bottom;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
